module.exports = __webpack_public_path__ + "static/29-hexagon-lion-face-804dcbd1603e8f6288db3ed8440c7a39.png";